<template>
  <div id="fund-factsheet">
    <div class="company-logos" v-show="isPrintView">
      <img class="company-logo company-logo--first" style="height:70px;" alt="Prudential Staff Pension Scheme logo"
        src="https://dc.prudentialstaffps.co.uk/assets/images/mandg-logo.svg">
      <img class="company-logo company-logo--last" alt="The Defined Contribution Section logo"
        src="https://dc.prudentialstaffps.co.uk/assets/images/psps-logo.svg">
    </div>

    <p class="page-title">Fund factsheets</p>
    <button class="btn btn-print print-hide" v-show="!isPrintView" v-on:click="printFactsheet">Print<img class="btn_icon"
        src="https://cdn.concertconsult.co.uk/1671-fund-factsheets/assets/icon-print.svg" alt="print icon"></button>
    <h1 class="factsheet-title">{{ factsheetData.name }}<span class="as-at-date" v-if="dataLoaded">as at {{ fullAsAtDate
    }}</span></h1>

    <div v-if="isPrintView" class="printModal print-hide">
      <div class="printModal__box">
        <p>The factsheet has opened this new window to allow you to print it in its entirety. If you'd like to print
          another copy click 'Print again' or click 'Close window' to return to the page you were viewing.</p>
        <button class="btn float-left" v-on:click="printFactsheetAgain">Print again <img class="btn_icon"
            src="https://cdn.concertconsult.co.uk/1671-fund-factsheets/assets/icon-print.svg" alt="print icon"></button>
        <button class="btn btn-default float-right" v-on:click="closeWindow">Close window</button>
        <div class="clear"></div>
      </div>
    </div>

    <FundSection v-for="(section, index) in factsheetData.sections" :key="section.index" :sectionIndex="index"
      :sectionData="section" :factsheetData="factsheetData" :isPrintView="isPrintView">
    </FundSection>
    <div v-show="dataNotFound">
      <h1>Factsheet not found</h1>
    </div>
    <div class="main-footer" v-show="isPrintView">
      <p>Prudential Staff Pension Scheme <span class="emphasis">DC Section Fund Fact Sheet</span></p>
      <p><small>Produced by the Trustee of the Prudential Staff Pension Scheme, 10 Fenchurch Avenue, London EC3M
          5AG.</small></p>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import apiData from './assets/raw_data_v2.json';
import { Chart } from 'chart.js';
import ChartJsPluginDataLabels from 'chartjs-plugin-datalabels';
import FundSection from './components/FundSection.vue';

Chart.register(ChartJsPluginDataLabels);

Chart.defaults.plugins.datalabels.anchor = 'end';
Chart.defaults.plugins.datalabels.align = 'end';
Chart.defaults.plugins.datalabels.offset = 0;
Chart.defaults.plugins.datalabels.color = 'black';
Chart.defaults.animation.duration = 1400;
Chart.defaults.backgroundColors = ['#222051', '#554e72', '#8e859f', '#d9d6de', '#81236c', '#9c5f8b', '#bd98b2', '#e9dee6', '#0d6d80', '#458a9c', '#8eb1bd', '#636466', '#acaeb1', '#474749']

export default {
  name: 'fund-factsheet',
  components: {
    ChartJsPluginDataLabels,
    FundSection
  },
  data: function () {
    return {
      factsheetData: {},
      isPrintView: false,
      dataNotFound: false,
      dataLoaded: false,
      factsheetURI: null
    }
  },
  methods: {
    printFactsheet: function () {
      window.open(
        process.env.VUE_APP_URL + '/?p=print&location=' + this.factsheetURI,
        '_blank'
      );
    },
    printFactsheetAgain: function () {
      window.print()
    },
    closeWindow: function () {
      window.close()
    }
  },
  mounted() {
    function getUrlVars() {
      var vars = [], hash;
      var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
      for (var i = 0; i < hashes.length; i++) {
        hash = hashes[i].split('=');
        vars.push(hash[0]);
        vars[hash[0]] = hash[1];
      }
      return vars;
    }
    function getFactsheetId() {
      var factsheetidFromQueryString = getUrlVars()['location'];
      var factsheetidFromWrapper = null;
      var factsheetWrapper = document.getElementById("app-wrapper");

      if (factsheetWrapper != null) {
        var factsheetidFromWrapper = document.getElementById("app-wrapper").dataset.factsheetid;
      }

      // If the wrapper element has a factsheet ID attribute
      // then use this as the factsheetID
      // Otherwise use the factsheetID from the query string.
      if (factsheetidFromWrapper != null && factsheetidFromWrapper.length > 0) {
        return factsheetidFromWrapper;
      } else {
        return factsheetidFromQueryString;
      }
    }
    this.factsheetURI = getFactsheetId();
    axios.get(process.env.VUE_APP_API_URL + '/api/v1.0/fund/' + this.factsheetURI).then(
      response => {
        this.factsheetData = response.data.data;
        this.dataLoaded = true;
        if (getUrlVars()['p'] == 'print') {
          this.isPrintView = true;
          Chart.defaults.global.animation.duration = 0;
          this.$nextTick(function () {
            window.print();
          });
        }
      }).catch((error) => {
        console.warn('Failed to load factsheet data');
      });
    // console.log(this.factsheetData.length);
    // if (Object.keys(this.factsheetData).length === 0 && this.factsheetData.constructor === Object) {
    //   this.dataNotFound = true;
    // }
  },
  computed: {
    fullAsAtDate: function () {
      return moment(this.factsheetData.as_at_date).format('D MMMM YYYY');
    }
  }
}
</script>

<style lang="scss">
#fund-factsheet {
  @import '../node_modules/bootstrap/scss/bootstrap-grid.scss';
  @import '../node_modules/bootstrap/scss/bootstrap-reboot.scss';
  @import '../node_modules/bootstrap/scss/_tables.scss';
  @import '../node_modules/bootstrap/scss/_type.scss';
  @import '../node_modules/bootstrap/scss/_utilities.scss';
  @import './styles/GlobalStyles.scss';

  font-size: 15px;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  position: relative;
  margin: 0 auto;

  .company-logos {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: 1em;

    .company-logo {
      max-width: 160px;
      align-self: center;
      flex: 0 0 auto;
    }

    .company-logo--first {
      margin-left: -10px;
    }
  }

  .as-at-date {
    display: block;
    font-size: 0.5em;
    margin-top: 0.5em;
  }

  .section {
    border-bottom: 1px solid lightgrey;
    margin-bottom: 2em;
  }

  .btn-print {
    position: absolute;
    right: 0;
    background: transparent;
    border: 0;
    padding: 0;
    font-size: 1.2em;
    font-weight: 600;

    .btn_icon {
      padding-left: 10px;
    }

    &:hover {
      opacity: 0.85;
      cursor: pointer;
    }

    @media screen and (max-width: 576px) {
      display: none;
    }
  }

  .printModal {
    position: fixed;
    z-index: 1100;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background-color: rgba(255, 255, 255, 0.8);
    color: white;

    .printModal__box {
      position: relative;
      top: 30%;
      width: 300px;
      background: #45176b;
      padding: 20px;
      border: 1px solid gray;
      border-radius: 10px;
      box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
      margin: 0 auto;

      .btn {
        background: white;
        border: 0;
        border-radius: 5px !important;
        padding: 5px;
        font-size: 1.1em;
        font-weight: 600;
        height: 40px;

        .btn_icon {
          height: 30px;
        }

        &:hover,
        &:active {
          cursor: pointer;
          background: rgba(255, 255, 255, 0.85);
        }
      }
    }

    .float-left {
      float: left;
    }

    .float-right {
      float: right;
    }

    .clear {
      clear: both;
      height: 0;
    }
  }

  .main-footer {
    .emphasis {
      font-weight: 700;
      color: $purple;
    }
  }
}
</style>
